import { ChangeDetectorRef, Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatSnackBar } from '@angular/material/snack-bar';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { PointLeaderboardService, ExpiredEvent } from '../../../utilities/services/point-leaderboard/point-leaderboard.service';
import { SkeletonLoaderComponent } from '../../shared/skeleton-loader/skeleton-loader.component';


@Component({
  selector: 'stupa-expired-points',
  standalone: true,
  imports: [MatTooltipModule, CommonModule, TranslateModule, SkeletonLoaderComponent],
  templateUrl: './expired-points.component.html',
  styleUrl: './expired-points.component.scss'
})
export class ExpiredPointsComponent implements OnChanges {

  constructor(
    private readonly leaderboardService: PointLeaderboardService,
    private readonly cdr: ChangeDetectorRef,
    private readonly snackBar: MatSnackBar
  ) {}

  @Input() participantId: number | null = null;
  @Input() categoryId: number | null = null;
  @Output() panelClose = new EventEmitter<void>();

  expiredEvents: ExpiredEvent[] = [];
  isLoading: boolean = false;
  errorMessage: string | null = null;
  ngOnChanges(changes: SimpleChanges): void {
    if ((changes['participantId'] || changes['categoryId']) && this.participantId && this.categoryId) {
      this.fetchExpiredPoints();
    }
  }

  private fetchExpiredPoints(): void {
    this.isLoading = true;
    this.errorMessage = null;
    this.expiredEvents = [];
    this.cdr.detectChanges();

    const seasonId = globalThis.window !== undefined && localStorage.getItem('seasonId')
      ? +localStorage.getItem('seasonId')!
      : null;

    if (!seasonId) {
      this.isLoading = false;
      this.errorMessage = 'Season not Found';
      this.snackBar.open('Season not Found', 'Close', {
        duration: 3000,
        panelClass: ['error']
      });
      this.cdr.detectChanges();
      return;
    }

    this.leaderboardService
      .getExpiredPoints(this.participantId!, seasonId, this.categoryId!)
      .subscribe({
        next: (response) => {
          this.expiredEvents = response.expired_events;
          this.isLoading = false;
          this.cdr.detectChanges();
        },
        error: (error) => {
          console.error('Error fetching expired points:', error);
          this.errorMessage = 'Failed to load expired points. Please try again.';
          this.isLoading = false;
          this.cdr.detectChanges();
        },
        complete: () => {
          this.isLoading = false;
          this.cdr.detectChanges();
        }
      });
  }

  trackById(index: number, item: unknown): string | number {
    if (item != null && typeof item === 'object' && 'id' in item) {
      const id = (item as { id?: string | number }).id;
      if (id != null) return id;
    }
    return index;
  }
}